import API from './API';

export default class Busca extends API {

  static lista(dados){
    return super.post(`/ws/busca`, dados);
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Busca.js